import { Link } from "react-router-dom";
import { Icon, Menu, Modal, TransitionablePortal } from "semantic-ui-react";
import { logout, UserData, UserRole } from "../../actions/authentificationActions";
import { ReactComponent as LogoWithoutText } from "../../icons/Logo.svg";
import { LanguageSelector } from "../../components/LanguageSelector/LanguageSelector";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

type Props = {
    open: boolean;
    closeModal: () => void;
    user: UserData;
};

export const HeaderMobile = ({ open, closeModal, user }: Props) => {
    const dispatch = useDispatch();
    const intl = useIntl();

    return (
        <TransitionablePortal
            open={open}
            onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
            transition={{ animation: "scale", duration: 300 }}
            id="hamburger-modal"
        >
            <Modal
                centered={false}
                basic
                onClose={() => closeModal()}
                open
                size="fullscreen"
                id="hamburger-modal"
            >
                <div className="vertical-menu-hamburger-header">
                    <div className="hamburger-modal-header">
                        <Menu.Item
                            id="logo-without-text"
                            as={Link}
                            to="/search"
                            header
                            content={<LogoWithoutText title="" />}
                            onClick={() => closeModal()}
                        />
                        <LanguageSelector />
                        <Icon
                            className="hamburger-icon"
                            name="close"
                            size="big"
                            onClick={() => closeModal()}
                        />
                    </div>
                    <Menu.Item
                        className="header-menu-options"
                        onClick={() => closeModal()}
                        as={Link}
                        to="/search"
                        content={intl.formatMessage({ id: "searchCrewMember" })}
                    />
                    {(user.role === UserRole.PowerUser || user.role === UserRole.OfficeUser) && (
                        <Menu.Item
                            className="header-menu-options"
                            as={Link}
                            to="/statistics"
                            content={intl.formatMessage({ id: "statistics" })}
                            onClick={() => closeModal()}
                        />
                    )}
                    {(user.role === UserRole.PowerUser || user.role === UserRole.OfficeUser) && (
                        <Menu.Item
                            className="header-menu-options"
                            onClick={() => closeModal()}
                            as={Link}
                            to="/inbox"
                            content={intl.formatMessage({ id: "inbox" })}
                        />
                    )}
                    {(user.role === UserRole.PowerUser || user.role === UserRole.OfficeUserViadonau)&& (
                        <Menu.Item
                            className="header-menu-options"
                            onClick={() => closeModal()}
                            as={Link}
                            to="/change-log"
                            content={intl.formatMessage({ id: "changeLog" })}
                        />
                    )}
                    {user.role === UserRole.PowerUser && (
                        <Menu.Item
                            className="header-menu-options"
                            onClick={() => closeModal()}
                            as={Link}
                            to="/manage-users"
                            content={intl.formatMessage({ id: "userManagement" })}
                        />
                    )}
                    {(user.role === UserRole.OfficeUserViadonau || user.role === UserRole.PowerUser) && (
                        <Menu.Item
                            as={Link}
                            to="/ics-aplications"
                            content={intl.formatMessage({ id: "icsAplications" })}
                        />
                    )}
                    {user.role === UserRole.PowerUser && (
                        <Menu.Item
                            as={Link}
                            to="/administrator-settings"
                            content={intl.formatMessage({ id: "administratorSettings" })}
                        />
                    )}
                    <Menu.Item as={Link} to="/manage-users">
                        <Icon name="user circle" size="large" />
                        <span className="header-menu-options">
                            {user.firstName + " " + user.lastName}
                        </span>
                    </Menu.Item>
                    <Menu.Item onClick={() => dispatch(logout())}>
                        <Icon name="sign-out" size="large" />
                        <span className="header-menu-options">
                            {intl.formatMessage({ id: "logout" })}
                        </span>
                    </Menu.Item>
                </div>
            </Modal>
        </TransitionablePortal>
    );
};
